import ReactGA from 'react-ga4';
import { RuntimeConfiguration } from '@/configuration';

const initializeGA = () => {
  // Replace with your Measurement ID
  // It ideally comes from an environment variable
  ReactGA.initialize(RuntimeConfiguration.GOOGLE_TAG_MANAGER_ID);
  // Don't forget to remove the console.log() statements
  // when you are done
};

const trackGAEvent = (eventName: string, params: unknown) => {
  // Send GA4 Event
  ReactGA.event(eventName, params);
};

export default initializeGA;
export { initializeGA, trackGAEvent };
